<template>
  <nav
    id="navbarDoorderTop"
    class="navbar navbar-expand-lg navbar-absolute fixed-top"
  >
    <div class="container-fluid">
      <div class="navbar-wrapper col-md-1">
        <div class="navbar-minimize">
          <button
            id="minimizeSidebar"
            class="btn btn-just-icon btn-white btn-fab btn-round"
          >
            <i class="text_align-center visible-on-sidebar-regular"
              ><dots-vertical-icon
            /></i>
            <span class="visible-on-sidebar-mini"><view-list-icon /></span>
          </button>
        </div>
      </div>

      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        aria-controls="navigation-index"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="sr-only">Toggle navigation</span>
        <span class="navbar-toggler-icon icon-bar"></span>
        <span class="navbar-toggler-icon icon-bar"></span>
        <span class="navbar-toggler-icon icon-bar"></span>
      </button>

      <div class="collapse navbar-collapse justify-content-end col-md-11">
        <div class="searchFormContainerDiv mr-auto" style="">
          <!-- <form class="form-inline navbar-form" style="">
            <div class="input-group input-group-search mx-auto">
              <div class="form-outline">
                <input
                  type="search"
                  id="form1"
                  class="form-control form-control-doorder"
                  placeholder="Search"
                  aria-describedby="search-button-addon"
                />
              </div>
              <div class="input-group-append">
                <button type="button" class="btn btn-default btnSearchNavbar">
                  <font-awesome-icon
                    icon="fa-solid fa-magnifying-glass"
                    size="xl"
                  />
                </button>
              </div>
            </div>
          </form> -->
        </div>
        <!-- end search div -->

        <ul class="nav navbar-nav navbar-right">
          <li class="nav-item dropdown nav-item-icon-dropdown ml-2">
            <b-dropdown
              id="navbarDropdownProfile"
              class="navbarDropdownMenuLinkDoorder m-0"
              size="sm"
              variant="link"
              toggle-class="text-decoration-none"
              left
              no-caret
              ><template #button-content>
                <div class="">
                  <div class="p-0 d-inline-block">
                    <b-avatar
                      :text="avatar_text"
                      rounded
                      class="avatar-doorder"
                    ></b-avatar>
                    <div
                      class="
                        p-0
                        pl-1
                        d-inline-block
                        text-left
                        align-self-center
                      "
                    >
                      <p class="profileNameNavbar profileDataDoorderNavbar">
                        {{ name }}
                      </p>
                      <p class="profileUserTypeNavbar profileDataDoorderNavbar">
                        {{ user_type }}
                      </p>
                    </div>
                  </div>
                </div>
              </template>
              <b-dropdown-item href="#">Edit Password</b-dropdown-item>
            </b-dropdown>
          </li>
          <!-- <li class="nav-item dropdown">
            <a
              href="#"
              class="nav-link"
              data-toggle="dropdown"
              id="navbarDropdownProfile"
            >
              <div class="userLogoNavbar">
                <span>SR</span>
              </div>
              <p class="profileNameNavbar">Sara reda</p>
              <p class="profileUserTypeNavbar">admin</p>
            </a>
            <div
              class="dropdown-menu dropdown-menu-right"
              aria-labelledby="navbarDropdownProfile"
            >
              <a class="dropdown-item" href="">Edit Password</a>
            </div>
          </li> -->
        </ul>
      </div>
    </div>
  </nav>
</template>
        
<script>
export default {
  name: "NavbarDoorder",
  data() {
    return {
      name: "",
      user_type: "Admin",
      avatar_text: "",
    };
  },
  mounted() {
    // console.log()
    // console.log(window.localStorage.getItem("user"))
    let user = JSON.parse(window.localStorage.getItem("user"));
    console.log(user);
    console.log(user.first_name);
    console.log(user.last_name);
    // let splittedName = user.name.split(" ");
    this.name = user.first_name+" "+user.last_name; //splittedName[0];
    this.user_type = user.type == 'user' ? 'Retailer' : user.type;

    this.avatar_text = user.first_name[0];
    if (user.last_name != null) {
      this.avatar_text += user.last_name[0];
    }

    // this.avatar_text = splittedName[0].charAt(0);
    // if (splittedName.length > 1) {
    //   this.avatar_text += splittedName[1].charAt(0);
    // }
    //user.first_name.charAt(0)+user.second_name.charAt(0)
  },
};
</script>



// WEBPACK FOOTER //
// src/components/partials/navbar_doorder.vue